import forEach from "ramda/es/forEach";
import keys from "ramda/es/keys";
import { CALL_API } from '../../../constants';
import { setRequestStatus } from '../../../redux/status/actions';
import { requestStates } from '../../../redux/status/constants';
import { appendApiRequestActions, checkAndAppendApiRequestActions } from '../../../utils';
import { createActionMeta } from '../../utils';
/**
 * status middleware
 *
 * @documented
 * @category api-middleware
 *
 */ const statusMiddleware = ()=>()=>(next)=>async (action)=>{
                const callAPI = action[CALL_API];
                if (!callAPI) {
                    return next(action);
                }
                const actionMeta = createActionMeta(callAPI.meta);
                const requestActions = {
                    onRequest: [
                        setRequestStatus({
                            requestUuid: actionMeta.requestUuid,
                            status: requestStates.REQUESTED
                        })
                    ],
                    onSuccess: [
                        setRequestStatus({
                            requestUuid: actionMeta.requestUuid,
                            status: requestStates.COMPLETED
                        })
                    ],
                    onError: [
                        setRequestStatus({
                            requestUuid: actionMeta.requestUuid,
                            status: requestStates.ERROR
                        })
                    ],
                    onCancel: [
                        setRequestStatus({
                            requestUuid: actionMeta.requestUuid,
                            status: requestStates.CANCELED
                        })
                    ]
                };
                const appendApiActions = appendApiRequestActions(callAPI.actions, requestActions);
                const checkAndAppendApiActions = checkAndAppendApiRequestActions(callAPI.actions, appendApiActions);
                forEach(checkAndAppendApiActions, keys(requestActions));
                return next({
                    [CALL_API]: {
                        ...callAPI,
                        meta: actionMeta,
                        actions: requestActions
                    }
                });
            };
export default statusMiddleware;
